import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailsHistorieStatus } from '../../../models/details-historie.model';

@Component({
  selector: 'app-details-historie-status',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './details-historie-status.component.html',
  styleUrl: './details-historie-status.component.scss',
})
export class DetailsHistorieStatusComponent {
  readonly status = input.required<DetailsHistorieStatus>();
  readonly fehlerText = input<string | null>(null);
  readonly retry = output<void>();

  protected readonly zeilen = [1, 2, 3];
}
